<template>
  <div class="mall-month-data-detail">

    <header class="detail-header">
      <div class="detail-header__left">
        <span class="detail-header-title">{{ current.name }}本月数据详情</span>
        <span class="detail-header-tips">
          新增模板量：<span class="num">{{ current.showkerAddTemplate || 0 }}</span>个；
          其中免费：<span class="num">{{ current.showkerFreeTemplate || 0 }}</span>个
        </span>
      </div>
      <div class="detail-header__right">
        <div
          class="close"
          @click="close">
          <svg-icon
            icon-class="fullscreen_close"
            class-name="fullscreen-icon" />
          <span>退出全屏</span>
        </div>
      </div>
    </header>

    <div class="detail-content">
      <template v-if="['gc', 'h5e'].includes(current.key)">
        <MallMonthDataDetail2
          v-if="contentVisible"
          :showker-id="data.showkerId"
          :data="current" />
      </template>
      <template v-else>
        <MallMonthDataDetail1
          v-if="contentVisible"
          :showker-id="data.showkerId"
          :data="current" />
      </template>
    </div>

    <footer class="detail-footer">
      <div class="detail-footer__inner">
        <i
          class="eqf-left"
          @click="prev"></i>
        <i
          class="eqf-right"
          @click="next"></i>
      </div>
    </footer>

  </div>
</template>

<script>
import MallMonthDataDetail1 from './MallMonthDataDetail1'
import MallMonthDataDetail2 from './MallMonthDataDetail2'

export default {
  name: 'MallMonthDataDetail',
  components: {
    MallMonthDataDetail1,
    MallMonthDataDetail2
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    },
    close: {
      type: Function,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      contentVisible: false,
      contentIndex: 0
    }
  },
  computed: {
    current() {
      return this.data.list[this.contentIndex]
    }
  },
  mounted() {
    this.changeContent(this.data.index)
  },
  methods: {
    // 替换内容
    changeContent(index) {
      this.contentVisible = false
      this.contentIndex = index

      this.$nextTick(() => {
        this.contentVisible = true
      })
    },
    // 后退
    prev() {
      let index = this.contentIndex
      if (this.contentIndex === 0) {
        index = this.data.list.length - 1
      } else {
        index--
      }

      this.changeContent(index)
    },
    // 前进
    next() {
      let index = this.contentIndex
      if (this.contentIndex === this.data.list.length - 1) {
        index = 0
      } else {
        index++
      }

      this.changeContent(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.mall-month-data-detail {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: hidden;

    .detail-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 28px;
      height: 72px;

      &-title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }

      &-level {
        display: inline-block;
        height: 16px;
        line-height: 12px;
        text-align: center;
        padding: 1px 4px;
        margin-left: 8px;
        font-size: 12px;
        color: #999;
        border-radius: 4px;
        border: 1px solid #BFBFBF;
      }

      &-tips {
        margin-left: 20px;
        font-size: 14px;
        color: #999;

        .num {
          color: #1261FF;
        }
      }

      .close {
        font-size: 14px;
        color: #333;
        cursor: pointer;
        display: flex;
        align-items: center;

        .fullscreen-icon{
          color: #666;
          font-size: 28px;
          margin-right: 4px;
        }

        &:hover {
          color: #1261FF;

          .fullscreen-icon {
            color: #1261FF;
          }
        }
      }
    }

    .detail-content {
      height: calc(100% - 72px - 60px);
      padding: 0 28px 20px 28px;
    }

    .detail-footer {
      height: 60px;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;

      &__inner {
        .eqf-left,
        .eqf-right {
          font-size: 40px;
          color: #999;
          cursor: pointer;

          &:hover {
            color: #1261FF;
          }
        }
      }
    }
}
</style>
